













import { Component, Prop, Vue } from "vue-property-decorator";

import { Alert } from "@/store/alerts";

@Component({})
export default class AlertList extends Vue {
  @Prop({ default: () => [] })
  private alerts!: Alert[];
}
